export const LOGOS = {
  veerox: "https://customer-assets-m6fa6gv7.emergentagent.net/job_55aad9b8-8327-4d78-b912-5c05f6f2b99a/artifacts/8g27h2af_veerox%20software.jpeg",
  workassignai: "https://customer-assets-m6fa6gv7.emergentagent.net/job_55aad9b8-8327-4d78-b912-5c05f6f2b99a/artifacts/7l78tmi4_work%20assign.jpeg",
  forexandmore: "https://customer-assets-m6fa6gv7.emergentagent.net/job_55aad9b8-8327-4d78-b912-5c05f6f2b99a/artifacts/6gwpfo46_forex%20and%20more.jpeg",
  dignityfood: "https://customer-assets-m6fa6gv7.emergentagent.net/job_55aad9b8-8327-4d78-b912-5c05f6f2b99a/artifacts/z9x2lne4_dfk.jpeg",
  beingfood: "https://customer-assets-m6fa6gv7.emergentagent.net/job_55aad9b8-8327-4d78-b912-5c05f6f2b99a/artifacts/ylwu94sw_being%20food.jpeg",
};

export const VENTURES = [
  {
    id: "workassignai",
    index: "01",
    name: "WorkAssign AI",
    tagline: "Your AI Employee. Always Working.",
    category: "AI Workforce",
    description:
      "24/7 AI employees that automate WhatsApp conversations, AI calling, lead qualification, follow-ups and appointment booking — a digital workforce that never sleeps.",
    tags: ["AI WhatsApp Agent", "AI Calling", "Lead Automation"],
    url: "https://www.workassignai.com/",
    logo: LOGOS.workassignai,
    accent: "#38BDF8",
    span: 2,
  },
  {
    id: "veeroxalgo",
    index: "02",
    name: "Veerox Algo",
    tagline: "The Trading OS that thinks before it trades.",
    category: "Trading Intelligence",
    description:
      "A 9-pillar autonomous trading intelligence platform for MT5 — market regime detection, Capital-First risk engine, AI Coach and portfolio optimization.",
    tags: ["MT5", "Risk-First AI", "Market Prediction"],
    url: "https://veeroxalgo.com/",
    logo: LOGOS.veerox,
    accent: "#00E5FF",
    span: 1,
  },
  {
    id: "workassign",
    index: "03",
    name: "WorkAssign",
    tagline: "AI Automation That Works While You Sleep.",
    category: "Enterprise SaaS",
    description:
      "Custom SaaS development, AI agents, CRM systems, business automation, web & mobile apps — the engine behind industry leaders with 100+ projects delivered.",
    tags: ["Custom SaaS", "AI Agents", "CRM & Automation"],
    url: "https://www.workassign.in/",
    logo: LOGOS.workassignai,
    accent: "#60A5FA",
    span: 1,
  },
  {
    id: "forexandmore",
    index: "04",
    name: "Forex and More",
    tagline: "Trade Smart. Trade Gold.",
    category: "Trading Software",
    description:
      "The #1 Gold Scalping EA for XAUUSD on MT5, trusted by 20,000+ traders — plus full-stack custom trading software development, from EAs to trading platforms.",
    tags: ["Gold Scalping EA", "XAUUSD", "Custom Trading Software"],
    url: "https://forexandmore.com/",
    logo: LOGOS.forexandmore,
    accent: "#F59E0B",
    span: 2,
  },
  {
    id: "dignityfood",
    index: "05",
    name: "Dignity Food Kitchen",
    tagline: "Food served with dignity.",
    category: "Food & Hospitality",
    description:
      "A modern kitchen brand crafting wholesome, hygienic meals — bringing restaurant-quality food experiences to everyday life.",
    tags: ["Cloud Kitchen", "Fresh Meals", "Quality First"],
    url: "https://www.dignityfoodkitchen.com",
    logo: LOGOS.dignityfood,
    accent: "#4ADE80",
    span: 1,
  },
  {
    id: "beingfood",
    index: "06",
    name: "Being Food",
    tagline: "Real Ingredients. Real Happiness.",
    category: "Food Brand",
    description:
      "FoodLikeHeaven — a premium food brand built on real ingredients and honest flavours, spreading happiness one plate at a time.",
    tags: ["FoodLikeHeaven", "Real Ingredients", "Premium Brand"],
    url: "https://www.beingfood.com",
    logo: LOGOS.beingfood,
    accent: "#A3E635",
    span: 1,
  },
];

export const CONTACT_INFO = {
  whatsapp: "+91 96850 99792",
  whatsappLink: "https://wa.me/919685099792",
  phone: "+91 22-69986006",
  phoneLink: "tel:+912269986006",
  emails: ["ceo@workassignai.com", "ceo@veeroxalgo.com", "admin@workassign.in"],
  location: "India",
};

const IMG = {
  waDashboard: "https://static.prod-images.emergentagent.com/jobs/55aad9b8-8327-4d78-b912-5c05f6f2b99a/images/4034622b92b9b9ab9a78449d5af17ba95de3359e2c95da0eece9261b8a9992b9.jpeg",
  waCalling: "https://static.prod-images.emergentagent.com/jobs/55aad9b8-8327-4d78-b912-5c05f6f2b99a/images/abd01bc9eb95226899d594d032782ace0ccbea2780443346200f610579aef11b.jpeg",
  algoTerminal: "https://static.prod-images.emergentagent.com/jobs/55aad9b8-8327-4d78-b912-5c05f6f2b99a/images/f236636bdcda396aee61db515efc3607d88dae0ef5c6d19ba42ecd44b552ca35.jpeg",
  algoRisk: "https://static.prod-images.emergentagent.com/jobs/55aad9b8-8327-4d78-b912-5c05f6f2b99a/images/7de929c3a6a3293504136b2731e68fbbcdeb0a628da1a264daf41ce0e428e466.jpeg",
  saas: "https://static.prod-images.emergentagent.com/jobs/55aad9b8-8327-4d78-b912-5c05f6f2b99a/images/a6e1568b9ba7e77ee40dc6d6d2e190a70f60b04b1baf8b51278e3351e7476096.jpeg",
  forexGold: "https://static.prod-images.emergentagent.com/jobs/55aad9b8-8327-4d78-b912-5c05f6f2b99a/images/e929e355608bb6abb435cedef2d496aad134891aa3434aa724862a789f15478a.jpeg",
  forexChart: "https://static.prod-images.emergentagent.com/jobs/55aad9b8-8327-4d78-b912-5c05f6f2b99a/images/0ba1b242efd5e52e3deae1e2a14a239dcf63edbe05bd0df9d77978c8076cd0aa.jpeg",
  dignityMeal: "https://static.prod-images.emergentagent.com/jobs/55aad9b8-8327-4d78-b912-5c05f6f2b99a/images/e332060c0ab79fd863241c39a89d6b102f7c72c8284ef9b3d0dcd5ba1f6f5215.jpeg",
  dignityKitchen: "https://static.prod-images.emergentagent.com/jobs/55aad9b8-8327-4d78-b912-5c05f6f2b99a/images/afa82cf7014a04851b8c95f4c16a2d3e0cf2a1dc3ef613140a0bd67724d03798.jpeg",
  beingSpread: "https://static.prod-images.emergentagent.com/jobs/55aad9b8-8327-4d78-b912-5c05f6f2b99a/images/07410379082cdb2be7140cb6bf4560ac6cb986472ce949532c117dd0473c5d55.jpeg",
};

export const VENTURE_DETAILS = {
  workassignai: {
    heroLine: "The AI employee revolution.",
    story: [
      "WorkAssign AI was born from a simple frustration — businesses lose leads every single day because humans can't reply at 3 AM. So we built employees that can.",
      "Today, WorkAssign AI deploys AI-powered WhatsApp agents, calling assistants and lead-qualification pipelines that work around the clock. No sick days, no missed follow-ups — just a digital workforce that compounds while you sleep.",
    ],
    services: [
      { title: "AI WhatsApp Agents", desc: "Human-like conversations that qualify, nurture and convert leads on WhatsApp 24/7." },
      { title: "AI Calling Assistant", desc: "Outbound and inbound AI voice calls that book appointments and follow up automatically." },
      { title: "Lead Qualification", desc: "Every enquiry scored, segmented and routed to the right pipeline instantly." },
      { title: "Appointment Booking", desc: "Calendar-aware scheduling handled end-to-end by your AI team." },
      { title: "CRM Sync", desc: "Every conversation, call and lead logged into your CRM in real time." },
      { title: "Analytics Dashboard", desc: "See exactly what your AI employees did — conversations, conversions and revenue." },
    ],
    stats: [
      { value: "24/7", label: "Always-on AI team" },
      { value: "3 sec", label: "Average response time" },
      { value: "100%", label: "Follow-up rate" },
    ],
    gallery: [IMG.waDashboard, IMG.waCalling],
  },
  veeroxalgo: {
    heroLine: "Trading intelligence that survives first.",
    story: [
      "Most trading systems chase profits. Veerox Algo was engineered around a harder question — how do you survive markets first, then scale? The answer became a 9-pillar autonomous trading intelligence platform for MT5.",
      "From market regime detection to a Capital-First risk engine and an AI Coach that learns your behaviour, Veerox Algo thinks before it trades — so your capital lives to trade another day.",
    ],
    services: [
      { title: "Market Regime Detection", desc: "Identifies trending, ranging and volatile regimes before committing capital." },
      { title: "Capital-First Risk Engine", desc: "Position sizing and drawdown control designed around survival, not greed." },
      { title: "AI Trade Coach", desc: "Learns from every trade and nudges you away from destructive patterns." },
      { title: "Portfolio Optimization", desc: "Balances strategies and instruments for smoother equity curves." },
      { title: "MT5 Automation", desc: "Native MetaTrader 5 execution with millisecond-grade automation." },
      { title: "Performance Analytics", desc: "Deep insight into every pillar, every position and every decision." },
    ],
    stats: [
      { value: "9", label: "Intelligence pillars" },
      { value: "MT5", label: "Native platform" },
      { value: "Risk-1st", label: "Capital-first engine" },
    ],
    gallery: [IMG.algoTerminal, IMG.algoRisk],
  },
  workassign: {
    heroLine: "The engine behind industry leaders.",
    story: [
      "WorkAssign began with a promise — automate business growth so completely that companies scale while their founders sleep. That promise has now shipped in 100+ delivered projects.",
      "From custom SaaS platforms and AI agents to CRM systems, web and mobile apps, WorkAssign is the enterprise engineering arm of the Veerox ecosystem — quietly powering businesses across industries.",
    ],
    services: [
      { title: "Custom SaaS Development", desc: "Enterprise-grade platforms designed, built and scaled end-to-end." },
      { title: "AI Agents", desc: "Autonomous agents that handle support, sales and operations." },
      { title: "CRM Systems", desc: "Pipelines, automation and reporting tailored to your sales motion." },
      { title: "Business Automation", desc: "Workflows that remove humans from repetitive work entirely." },
      { title: "Web & Mobile Apps", desc: "Premium apps with the polish of consumer products." },
      { title: "Growth Marketing", desc: "Funnels and campaigns wired directly into your automation stack." },
    ],
    stats: [
      { value: "100+", label: "Projects delivered" },
      { value: "360°", label: "Business automation" },
      { value: "24/7", label: "Support & monitoring" },
    ],
    gallery: [IMG.saas, IMG.waDashboard],
  },
  forexandmore: {
    heroLine: "Trade smart. Trade gold.",
    story: [
      "Gold is the most brutal market in retail trading — and the most rewarding for those with an edge. Forex and More built that edge: the #1 Gold Scalping EA for XAUUSD on MT5, now trusted by 20,000+ traders worldwide.",
      "Beyond the flagship EA, the team builds full-stack custom trading software — from expert advisors and indicators to complete trading platforms — for traders and funds who want technology that performs under fire.",
    ],
    services: [
      { title: "Gold Scalping EA", desc: "The flagship XAUUSD expert advisor engineered for precision scalping." },
      { title: "News Filter Protection", desc: "Automatically stands aside during high-impact news events." },
      { title: "Prop-Firm Ready", desc: "Settings tuned for prop-firm drawdown and consistency rules." },
      { title: "Custom EA Development", desc: "Your strategy, coded and battle-tested on MT4/MT5." },
      { title: "Trading Platforms", desc: "Complete platforms, dashboards and copy-trading systems." },
      { title: "Signal Systems", desc: "Reliable signal delivery infrastructure for communities and funds." },
    ],
    stats: [
      { value: "20K+", label: "Traders trust us" },
      { value: "XAUUSD", label: "Specialist focus" },
      { value: "#1", label: "Gold scalping EA" },
    ],
    gallery: [IMG.forexGold, IMG.forexChart],
  },
  dignityfood: {
    heroLine: "Food served with dignity.",
    story: [
      "Dignity Food Kitchen started with a belief — that everyday meals deserve the same respect as fine dining. Fresh ingredients, honest preparation and hygiene that never gets compromised.",
      "Today the kitchen crafts wholesome, restaurant-quality meals for homes and workplaces — proving that the Veerox obsession with quality works just as well on a plate as it does in code.",
    ],
    services: [
      { title: "Cloud Kitchen Operations", desc: "Modern kitchen infrastructure built for consistency at scale." },
      { title: "Daily Fresh Meals", desc: "Made-to-order meals cooked fresh, never reheated stock." },
      { title: "Corporate Catering", desc: "Reliable, wholesome catering for teams and events." },
      { title: "Hygiene-First Prep", desc: "Strict hygiene standards at every step of preparation." },
      { title: "Custom Meal Plans", desc: "Menus tailored to dietary needs and preferences." },
      { title: "Doorstep Delivery", desc: "Hot, fresh and on time — every single day." },
    ],
    stats: [
      { value: "100%", label: "Fresh ingredients" },
      { value: "Daily", label: "Made-to-order meals" },
      { value: "5★", label: "Hygiene standards" },
    ],
    gallery: [IMG.dignityMeal, IMG.dignityKitchen],
  },
  beingfood: {
    heroLine: "Real ingredients. Real happiness.",
    story: [
      "Being Food — FoodLikeHeaven — is built on a stubborn refusal: no shortcuts, no artificial anything. Just real ingredients treated with real care.",
      "From sourcing to the final plate, every Being Food product carries the promise of honest flavour — spreading happiness one plate at a time, the Veerox way.",
    ],
    services: [
      { title: "Premium Food Products", desc: "A curated range built on quality-first sourcing." },
      { title: "Real-Ingredient Recipes", desc: "No artificial colours, flavours or shortcuts — ever." },
      { title: "Artisanal Preparation", desc: "Small-batch care with consistent, heavenly taste." },
      { title: "Quality Sourcing", desc: "Ingredients selected from trusted growers and suppliers." },
      { title: "Brand Partnerships", desc: "Collaborations with kitchens, retailers and creators." },
      { title: "Retail & Online", desc: "Available where you shop — offline and online." },
    ],
    stats: [
      { value: "100%", label: "Real ingredients" },
      { value: "0", label: "Artificial shortcuts" },
      { value: "∞", label: "Real happiness" },
    ],
    gallery: [IMG.beingSpread, IMG.dignityMeal],
  },
};
